import { render } from "./SchoolEditTableRowImage.vue?vue&type=template&id=c6cc58b2&scoped=true&ts=true"
import script from "./SchoolEditTableRowImage.vue?vue&type=script&lang=ts"
export * from "./SchoolEditTableRowImage.vue?vue&type=script&lang=ts"

import "./SchoolEditTableRowImage.vue?vue&type=style&index=0&id=c6cc58b2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cc58b2"]])

export default __exports__